// eslint-disable-next-line
import isChromatic from "chromatic/isChromatic";
export var slowSpring = isChromatic() ? {
    type: "just",
    delay: 0
} : {
    type: "spring",
    mass: 1,
    stiffness: 100,
    damping: 20,
    restDelta: 0.001
};

//# sourceMappingURL=slowSpring.js.map